<template>
  <DefaultLayout>
    <template v-slot:header>
      <CoastHeader :hasBackButton="true" :is-modal="!!selectedDraft"  :title="$t('HumanActivities')"></CoastHeader>
    </template>
    <FormControl @onSubmit="handleSubmit" autocomplete="off" ref="FormControl">
      <FieldWrapper ionItemClass="camera-item" name="files">
        <UploadImage @input="setImages" :images="files"></UploadImage>
      </FieldWrapper>

      <FieldWrapper>
        <ion-text lines="none" color="primary">
          Current Date: {{ currentDatetime.date }}, {{ formatAMPM(currentDatetime.time) }}
        </ion-text>
      </FieldWrapper>

      <ion-item class="submission-text" lines="none">
        <ion-row>
          <ion-text>{{ $t('Was the observation date different?') }}</ion-text>
          <ion-text @click="toggleDatetime(true)" class="add" color="primary" v-if="!differentDate">
            {{ $t('+ Add another date') }}
          </ion-text>
          <ion-text @click="toggleDatetime(false)" class="add" color="primary" v-else>
            {{ $t('- Remove the observation date') }}
          </ion-text>
        </ion-row>
      </ion-item>

      <FieldWrapper v-if="differentDate" :label="$t('Date *')" ionItemClass="border-full" name="submitted_at">
        <ion-datetime :placeholder="$t('Select Date')" @ionChange="hideError('submitted_at')"
                      presentation="month-day-year"
                      v-model="datetime.date"></ion-datetime>
        <Calendar class="date-icon"></Calendar>
      </FieldWrapper>

      <FieldWrapper v-if="differentDate" :label="$t('Time *')" ionItemClass="border-full" name="submitted_at">
        <ion-datetime :placeholder="$t('Select Time')" @ionChange="hideError('submitted_at')" display-format="HH:mm"
                      v-model="datetime.time"></ion-datetime>
        <Time class="time-icon"></Time>
      </FieldWrapper>

      <FieldWrapper :label="$t('People on beach *')" ionItemClass="border-full" name="people_on_beach">
        <ion-input :placeholder="$t('People on beach')" @ionChange="hideError('people_on_beach')" inputmode="numeric"
                   type="number"
                   v-model="form.people_on_beach"></ion-input>
      </FieldWrapper>

      <FieldWrapper :label="$t('Water activities (no motor) *')" ionItemClass="border-full"
                    name="water_activities_no_motor">
        <ion-input :placeholder="$t('Water activities')" @ionChange="hideError('water_activities_no_motor')"
                   inputmode="numeric"
                   type="number"
                   v-model="form.water_activities_no_motor"></ion-input>
      </FieldWrapper>

      <FieldWrapper :label="$t('Water activities (motor) *')" ionItemClass="border-full" name="water_activities_motor">
        <ion-input :placeholder="$t('Water activities (motor) *')" @ionChange="hideError('water_activities_motor')"
                    interface="action-sheet" inputmode="numeric" type="number"
                    v-model="form.water_activities_motor">
        </ion-input>
      </FieldWrapper>

      <FieldWrapper :label="$t('Motorized vehicles (on beach) *')" ionItemClass="border-full" name="motorized_vehicles">
        <ion-input :placeholder="$t('Motorized vehicles (on beach)')" @ionChange="hideError('motorized_vehicles')" inputmode="numeric" type="number"
                    v-model="form.motorized_vehicles">
        </ion-input>
      </FieldWrapper>

      <FieldWrapper :label="$t('Dogs on beach *')" ionItemClass="border-full" name="dogs_on_beach">
        <ion-input :placeholder="$t('Dogs on beach')" @ionChange="hideError('dogs_on_beach')" inputmode="numeric" type="number"
                    v-model="form.dogs_on_beach">
        </ion-input>
      </FieldWrapper>

      <FieldWrapper :label="$t('Notes')" ionItemClass="border-full">
        <ion-textarea :placeholder="$t('Enter any notes here...')" cols="20" rows="7"
                      v-model="form.notes"></ion-textarea>
      </FieldWrapper>

      <GoogleUserLocation
          :location="{
              longitude: form.longitude,
              latitude: form.latitude
            }"
          @userLocation="setLocationToForm">
      </GoogleUserLocation>

      <ion-item class="primary-button" lines="none">
        <ion-button expand="block" type="submit">{{ $t('Submit') }}</ion-button>
      </ion-item>
      <ion-item v-if="selectedDraft" class="primary-button">
        <ion-button expand="block" @click="clearDraftAndRedirect">{{ $t('Clear Draft') }}</ion-button>
      </ion-item>
    </FormControl>
  </DefaultLayout>
</template>

<script>
  import {IonDatetime, IonItem, IonText, IonRow, IonTextarea, IonInput, IonButton} from '@ionic/vue'
  import DefaultLayout from "@/views/layouts/default.vue"
  import CoastHeader from "@/components/CoastHeader.vue"
  import GoogleUserLocation from "@/components/GoogleUserLocation.vue"
  import Calendar from "@/components/icons/Calendar.vue"
  import Time from "@/components/icons/Time.vue"
  import FormControl from "@/components/FormControl"
  import FieldWrapper from "@/components/FieldWrapper"
  import UploadImage from "@/components/UploadImage"
  import '@/theme/components/form.scss'
  import moment from "moment"
  import ApiService from "@/services/api.service";
  import {mapGetters} from "vuex";
  import {alertController, modalController} from "@ionic/core";
  import CongratulationModal from "@/components/CongratulationModal";
  import { Device } from '@capacitor/device';
  import InteractsWithDrafts from "@/mixins/InteractsWithDrafts";

  export default {
    name: "HumanActivity",
    mixins: [InteractsWithDrafts],
    components: {
      IonDatetime,
      IonItem,
      IonText,
      IonTextarea,
      IonInput,
      IonRow,
      IonButton,
      FormControl,
      FieldWrapper,
      UploadImage,
      DefaultLayout,
      CoastHeader,
      Calendar,
      Time,
      GoogleUserLocation
    },

    data() {
      return {
        form: {},
        currentDatetime: {
          date: `${moment(new Date()).format('MMMM')} ${moment(new Date()).format('D-Y')}`,
          time: new Date()
        },
        datetime: {
          date: null,
          time: null
        },
        differentDate: false,
        files: [],
        errors: []
      }
    },

    computed: {
      ...mapGetters("auth", ["user"]),
      localError () {
        return {
          // "created_at": ["The created at field is required."],
          "people_on_beach": ["The people on beach field is required."],
          "water_activities_no_motor": ["The water activities no motor field is required."],
          "water_activities_motor": ["The water activities motor field is required."],
          "motorized_vehicles": ["The motorized vehicles field is required."],
          "dogs_on_beach": ["The dogs on beach field is required."]
        }
      }
    },

    created () {
      this.restoreObservationDate();
    },

    beforeRouteLeave(to, from , next) {
      return this.handleBeforeRouteLeave(to, from , next);
    },

    methods: {
      async handleSubmit() {
        const data = new FormData()

        const deviceInfo = await this.getDeviceInfo();
        data.append('device', JSON.stringify(deviceInfo));

        if (this.datetime && this.datetime.time && this.datetime.date) {
          data.append('submitted_at', this.formattedDates(this.datetime))
        }

        if (this.files) {
          this.files.forEach(image => {
            data.append('files[]', image.file, image.file.name)
          })
        }

        data.append('form_type', this.$options.name)

        data.append('user_id', this.user.id)

        for (const [key, value] of Object.entries(this.form)) {
          data.append(key, value)
        }

        if (!navigator.onLine) {
          const errKeys = Object.keys(this.localError)
          const formKeys = Array.from(data.keys())
          const diff = errKeys.filter(x => !formKeys.includes(x));
          const errors = {}

          diff.map((index) => {
            errors[index] = this.localError[index]
          })

          this.errors = errors
          this.$refs.FormControl.setErrors(errors)

          if (Object.keys(errors).length) {
            const errorAlert = await alertController.create({
              header: this.$t('Failed to submit'),
              subHeader: this.$t('The data was invalid'),
              message: this.$t('Please fill all the required fields'),
              buttons: [this.$t('OK')]
            });

            await errorAlert.present()

            return
          }
        }

        // If there's no internet, inform the user, save as draft and don't attempt to submit
        await this.checkInternetConnection();

        try {
          await ApiService.post('/submission', data)
            .then(() => {
              this.persistObservationDate()
              this.openModal()
              this.$store.dispatch('auth/getUser')
            })

            .catch(async (err) => {
              const errorAlert = await alertController.create({
                header: this.$t('Failed'),
                subHeader: this.$t('Submission Failed'),
                message: err.response.data.message,
                buttons: [this.$t('OK')]
              });

              if (err.response?.data?.errors) {
                this.$refs.FormControl.setErrors(err.response.data.errors)
                this.errors = err.response.data.errors
              }

              await errorAlert.present()
            })
        } catch (err) {
          const errorAlert = await alertController.create({
            header: this.$t('Failed to submit'),
            subHeader: this.$t('No Internet Connection'),
            message: this.$t('Your report will be stored and sent once you will be online'),
            buttons: [this.$t('OK')]
          });

          await errorAlert.present()
        }
        this.clearDraft();
      },

      formattedDates() {
        if (this.datetime && this.datetime.date && this.datetime.time) {
          const time = new Date(this.datetime.time);
          return moment(this.datetime.date)
              .set('hour', time.getHours())
              .set('minutes', time.getMinutes())
              .set('seconds', time.getSeconds())
              .toISOString()
        }
      },

      formatAMPM(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes + ' ' + ampm;
      },

      setLocationToForm(data) {
        if (data.longitude) {
          this.form.longitude = data.longitude
        }

        if (data.latitude) {
          this.form.latitude = data.latitude
        }
      },

      setImages(data) {
        this.files = [...data]
      },

      toggleDatetime(value) {
        this.differentDate = value
      },

      async openModal() {
        const modal = await modalController
          .create({
            component: CongratulationModal,
            componentProps: {
              resetForm: () => { this.form = {}; this.files = []; },
            },
            cssClass: 'success',
            backdropDismiss:false
          });
        return await modal.present();
      },

      hideError(key) {
        if (key === 'created_at') {
          if (this.dates[0] && this.dates[0].date && this.dates[0].time) {
            delete this.errors[key]
            this.$refs.FormControl.setErrors(this.errors)
          }
        } else {
          delete this.errors[key]
          this.$refs.FormControl.setErrors(this.errors)
        }
      },
      async getDeviceInfo() {
        return await Device.getInfo();
      }
    }
  }
</script>

<style scoped>

</style>
